(() => {
  const pageRoot = document.querySelector("body.template-page-custom-micro-walnut");

  if (!pageRoot) {
    return;
  }

  const desktopQuery = window.matchMedia("(min-width: 990px)");
  const stateMap = new WeakMap();

  function getState(controls) {
    if (!stateMap.has(controls)) {
      stateMap.set(controls, {
        bound: false,
        activePanelId: null,
      });
    }

    return stateMap.get(controls);
  }

  function getOptionsContainer(controls) {
    return controls.querySelector(".tda-customizer-customization-options-container");
  }

  function getPanels(optionsContainer) {
    return Array.from(optionsContainer ? optionsContainer.children : []).filter((child) => {
      if (!child.id) {
        return false;
      }

      return (
        child.id.indexOf("tda-customizer-customization-option-") === 0 ||
        child.id.indexOf("swiper-summary-container-customization-option-") === 0
      );
    });
  }

  function getAppVisiblePanels(panels) {
    return panels.filter((panel) => panel.style.display !== "none");
  }

  function getPanelTitle(panel, index) {
    const titleNode =
      panel.querySelector(".tda-customizer-customization-option-title") ||
      panel.querySelector("strong");

    const title = titleNode ? titleNode.textContent.trim() : "";
    return title || "Step " + String(index + 1);
  }

  function createNavButton(direction) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "cmw-desktop-stepper-btn cmw-desktop-stepper-btn--" + direction;
    button.setAttribute("aria-label", direction === "prev" ? "Previous option" : "Next option");
    button.innerHTML =
      direction === "prev"
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 19L8 12L15 5"></path></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 19L16 12L9 5"></path></svg>';
    return button;
  }

  function ensureNav(controls) {
    const optionsContainer = getOptionsContainer(controls);

    if (!optionsContainer) {
      return null;
    }

    let nav = controls.querySelector(".cmw-desktop-stepper");

    if (!nav) {
      nav = document.createElement("div");
      nav.className = "cmw-desktop-stepper";

      const prev = createNavButton("prev");
      const label = document.createElement("div");
      label.className = "cmw-desktop-stepper-label";
      const next = createNavButton("next");

      nav.appendChild(prev);
      nav.appendChild(label);
      nav.appendChild(next);

      controls.insertBefore(nav, optionsContainer);

      prev.addEventListener("click", () => moveStep(controls, -1));
      next.addEventListener("click", () => moveStep(controls, 1));
    } else if (nav.nextElementSibling !== optionsContainer) {
      controls.insertBefore(nav, optionsContainer);
    }

    return nav;
  }

  function setActivePanel(controls, requestedId) {
    const state = getState(controls);
    const optionsContainer = getOptionsContainer(controls);

    if (!optionsContainer) {
      return;
    }

    const panels = getPanels(optionsContainer);
    const visiblePanels = getAppVisiblePanels(panels);

    if (!visiblePanels.length) {
      state.activePanelId = null;
      return;
    }

    let activePanel =
      (requestedId && visiblePanels.find((panel) => panel.id === requestedId)) ||
      (state.activePanelId && visiblePanels.find((panel) => panel.id === state.activePanelId)) ||
      visiblePanels[0];

    visiblePanels.forEach((panel) => {
      panel.classList.toggle("cmw-desktop-step-hidden", panel !== activePanel);
    });

    panels.forEach((panel) => {
      if (!visiblePanels.includes(panel)) {
        panel.classList.remove("cmw-desktop-step-hidden");
      }
    });

    const nav = ensureNav(controls);

    if (!nav) {
      state.activePanelId = activePanel.id;
      return;
    }

    const prev = nav.querySelector(".cmw-desktop-stepper-btn--prev");
    const next = nav.querySelector(".cmw-desktop-stepper-btn--next");
    const label = nav.querySelector(".cmw-desktop-stepper-label");
    const activeIndex = visiblePanels.indexOf(activePanel);

    label.textContent = getPanelTitle(activePanel, activeIndex);
    prev.disabled = activeIndex <= 0;
    next.disabled = activeIndex >= visiblePanels.length - 1;
    nav.style.display = visiblePanels.length > 1 ? "flex" : "none";

    state.activePanelId = activePanel.id;
  }

  function restoreDesktopPanels(controls) {
    const optionsContainer = getOptionsContainer(controls);

    if (optionsContainer) {
      getPanels(optionsContainer).forEach((panel) => {
        panel.classList.remove("cmw-desktop-step-hidden");
      });
    }

    const nav = controls.querySelector(".cmw-desktop-stepper");

    if (nav) {
      nav.remove();
    }
  }

  function syncControls(controls) {
    if (!desktopQuery.matches) {
      restoreDesktopPanels(controls);
      return;
    }

    setActivePanel(controls);
  }

  function moveStep(controls, direction) {
    if (!desktopQuery.matches) {
      return;
    }

    const optionsContainer = getOptionsContainer(controls);

    if (!optionsContainer) {
      return;
    }

    const state = getState(controls);
    const visiblePanels = getAppVisiblePanels(getPanels(optionsContainer));

    if (!visiblePanels.length) {
      return;
    }

    const currentIndex = Math.max(
      0,
      visiblePanels.findIndex((panel) => panel.id === state.activePanelId)
    );
    const nextIndex = Math.max(0, Math.min(visiblePanels.length - 1, currentIndex + direction));

    if (nextIndex === currentIndex) {
      return;
    }

    setActivePanel(controls, visiblePanels[nextIndex].id);
    controls.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function bindControls(controls) {
    const state = getState(controls);

    if (state.bound) {
      return;
    }

    state.bound = true;

    controls.addEventListener("click", (event) => {
      if (!desktopQuery.matches) {
        return;
      }

      if (event.target.closest(".cmw-desktop-stepper")) {
        return;
      }

      if (
        !event.target.closest(
          ".tda-customizer-customization-option-value, .tda-customizer-customization-option select, .tda-customizer-customization-option input, .tda-customizer-customization-option textarea"
        )
      ) {
        return;
      }

      window.setTimeout(() => syncControls(controls), 80);
      window.setTimeout(() => syncControls(controls), 220);
    });
  }

  function init() {
    pageRoot.querySelectorAll(".tda-customizer-controls-container").forEach((controls) => {
      bindControls(controls);
      syncControls(controls);
    });
  }

  const delayedInits = [200, 700, 1500, 3000];

  delayedInits.forEach((delay) => {
    window.setTimeout(init, delay);
  });

  if (typeof desktopQuery.addEventListener === "function") {
    desktopQuery.addEventListener("change", init);
  } else if (typeof desktopQuery.addListener === "function") {
    desktopQuery.addListener(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
